export const SELECT_FILTER = 'SELECT_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const REPLACE_FILTERS = 'REPLACE_FILTERS';
export const FACET_ITEM_APPLIED = 'FACET_ITEM_APPLIED';
export const FACET_ITEM_REMOVED = 'FACET_ITEM_REMOVED';

export const COLOR_GROUP_ID = '@colorGroup';
export const TECHNOLOGY_GROUP_ID = '@technologyGroup';
export const PRODUCT_FEATURES_GROUP_ID = '@productFeatures';
export const SIZE_GROUP_ID = 'size';
export const SPAN_BEHAVIOR_COLORS = ['black-white', 'white'];

export const SUBSECTION_MAX_FACET_VALUES = 6;

export const SECTION_MAX_FACET_VALUES = 8;

export const FACET_HOVER_DELAY = 250;

export const FACET_ITEM_MAX_CHARACTERS = 18;

export const WOMEN_LEISUREWEAR_IDS = ['Size_003', 'Size_004', 'Size_005', 'Size_006', 'Size_007'];
